export default __webpack_public_path__ + "static/media/checkbox.ae76d127.svg";